import { toast } from "react-toastify";
import axios from "axios";

export const showSuccess = (message) => {
  return toast.success(message || "Successed");
};

/** Turn common API error bodies into a string for toast (objects are not rendered by react-toastify). */
function messageFromResponseData(data) {
  if (data == null) return "";
  if (typeof data === "string") return data;
  if (typeof data !== "object") return String(data);

  if (Array.isArray(data.errors) && data.errors.length) {
    return data.errors
      .map((item) =>
        typeof item === "string"
          ? item
          : item && typeof item === "object" && item.message != null
            ? String(item.message)
            : JSON.stringify(item)
      )
      .join("\n");
  }

  if (data.errors && typeof data.errors === "object" && !Array.isArray(data.errors)) {
    const parts = Object.entries(data.errors).flatMap(([key, val]) => {
      if (Array.isArray(val)) return val.map((v) => `${key}: ${v}`);
      if (val != null) return [`${key}: ${val}`];
      return [];
    });
    if (parts.length) return parts.join("\n");
  }

  if (typeof data.error === "string") return data.error;
  if (typeof data.message === "string") return data.message;
  try {
    return JSON.stringify(data);
  } catch {
    return "Error occurred. Try again";
  }
}

/** Readable API message from an axios error (for inline form errors). */
export function getApiErrorMessage(error) {
  if (!error?.response || error.response.data === undefined) return "";
  return messageFromResponseData(error.response.data);
}

export const showError = async (error) => {
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data === "Unauthenticated"
  )
    return;

  if (
    (error &&
      error.response &&
      error.response.data &&
      error.response.data === "SESSION_EXPIRED") ||
    error === "SESSION_EXPIRED"
  ) {
    await axios.delete("/api/auth/logins");
    window.location.reload();
    return;
  }

  if (error && error.response && error.response.data !== undefined) {
    const data = error.response.data;
    if (typeof data === "string" && data.includes("<html"))
      return toast.error("Error occurred. Try again later.");
    const msg = messageFromResponseData(data);
    if (msg.includes("<html")) return toast.error("Error occurred. Try again later.");
    if (msg) return toast.error(msg);
  } else if (error && typeof error === "string") {
    return toast.error(error);
  } else if (error && error.message) return toast.error(error.message);
  else return toast.error(error || "Error occurred. Try again");
};
